import { useEffect, useState } from 'react';

/* eslint-disable import/prefer-default-export */
const urlParams = new URLSearchParams(window.location.search);

/**
 * @description simple hook to check if optimizely is running or a query param is present
 */
export function useOptimizely() {
  const values = urlParams.get('optimizely');
  const [isOptimizelyLoaded, setOptimizelyLoaded] = useState(!!window?.optimizely?.initialized);
  const [isOptimizelyExperimentDecided, setIsOptimizelyExperimentDecided] = useState(!!window?.optimizely?.initialized);
  const onCampaignDecided = (event) => {
    // for each experiment we are going set false and true.. so that we will recalculate the global variables
    setIsOptimizelyExperimentDecided(false);
    // eslint-disable-next-line no-console
    console.log(
      `The visitor is now seeing variation ${event.data.decision.variationId} of campaign ${event.data.campaign.name}`
    );
    setTimeout(() => {
      setIsOptimizelyExperimentDecided(true);
    }, 0);
  };
  const onInitialized = () => {
    // eslint-disable-next-line no-console
    console.log(`Project ${window.optimizely.get('data').projectId} is initialized`);
    setOptimizelyLoaded(true);
  };

  window.optimizely = window.optimizely || [];
  // optimizely life cycle events - https://docs.developers.optimizely.com/web/docs/add-listener
  useEffect(() => {
    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'initialized',
      },
      handler: onInitialized,
    });
    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'campaignDecided',
      },
      handler: onCampaignDecided,
    });
  }, []);

  const isAValidOptimizelyParam = (testName) => {
    const all = values?.split(',') || [];

    if (values === 'all' || (all && all.includes('all'))) return true;

    return all.includes(testName);
  };
  /**
   * @param {string} [props.hasTestParam] - we use this param to check if we are overriding a test with an urlParam;
   * @param {string} [props.keyToRead] - we use this param to read a particular key from the optimazely object;
   * @returns boolean
   */
  const ifOptimizely = ({ hasTestParam, keyToRead }) => {
    return isAValidOptimizelyParam(hasTestParam) || (window.buyFlow && window.buyFlow[keyToRead]);
  };

  /**
   * @param {string} [props.hasTestParam] - we use this param to check if we are overriding a test with an urlParam;
   * @param {string} [props.keyToRead] - we use this param to read a particular key from the optimazely object;
   * @returns boolean
   * @description Looks in the ctct_sms namespace for optimizely information. This is ONLY for sms project optimizely tests.
   * There are not currently any sms optimizely tests, so right now this method is unused.
   */
  const ifSmsOptimizely = ({ hasTestParam, keyToRead }) => {
    return isAValidOptimizelyParam(hasTestParam) || (window.ctct_sms && window.ctct_sms[keyToRead]);
  };

  return { ifOptimizely, ifSmsOptimizely, isOptimizelyLoaded, isOptimizelyExperimentDecided };
}
